import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Tooltip } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { HeartPlusIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

type Props = {
  // Bypass the member-table detail flag on surfaces that require the indicator.
  alwaysVisible?: boolean,
};

const ServiceAnimalIndicator = ({ alwaysVisible = false }: Props) => {
  const { householdViewMorePetInfo } = useFlags();
  return alwaysVisible || householdViewMorePetInfo ? (
    <Tooltip
      title={'Service Animal'}
      placement={'top'}
      containerSX={{ height: 21 }}
    >
      <HeartPlusIcon />
    </Tooltip>
  ) : null;
};

export default ServiceAnimalIndicator;
